import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/auth/forgot-password`, { email });
      setMessage(res.data.message);
    } catch {
      setMessage("Si existe una cuenta asociada a ese correo, recibirás un enlace para restablecer tu contraseña.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4" data-testid="admin-forgot-password-page">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="h-12 w-12 rounded-xl bg-[#028CF8] flex items-center justify-center mb-3">
            <ShieldCheck className="h-6 w-6 text-white" />
          </div>
          <h1 className="font-bold text-lg text-slate-900">Recuperar contraseña</h1>
        </div>
        {message ? (
          <p data-testid="admin-forgot-password-message" className="text-sm text-slate-700 text-center">{message}</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-600 mb-1 block">Email</label>
              <input
                data-testid="admin-forgot-password-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-11 px-3 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#028CF8]"
              />
            </div>
            <button
              type="submit"
              data-testid="admin-forgot-password-submit"
              disabled={loading}
              className="w-full h-11 rounded-lg bg-[#028CF8] hover:bg-[#0270C5] text-white font-semibold text-sm flex items-center justify-center gap-2 disabled:opacity-70"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enviar enlace"}
            </button>
          </form>
        )}
        <div className="text-center mt-5">
          <Link to="/admin/login" data-testid="admin-back-to-login-link" className="text-xs text-[#028CF8] font-medium hover:underline">
            Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
